import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  HostListener,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { AlertService } from '../../_alert';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import moment from 'moment';
import { DatastoreService } from '../../services/datastore.service';

@Component({
  selector: 'app-mat-calendar',
  templateUrl: './mat-calendar.component.html',
  styleUrls: ['./mat-calendar.component.scss'],
})
export class MatCalendarComponent implements OnInit {
  minDate;
  maxDate;
  startDate;
  selectedDate: Date;
  currentDate: Date;
  slots: any[] = [];
  tempSlots: any[] = [];
  selectedSlot;
  availableDays: any;
  @Input() service: any;
  @Input() location: any;
  @Input() component: any;
  @Output() selectSlotUpdate = new EventEmitter<boolean>();
  @ViewChild('calendar') calendar: any;
  a11yMessage: string = '';


  constructor(
    private availabilityService: AvailabilityService,
    private alertService: AlertService,
    private translateService: TranslateService,
    private spinner: NgxSpinnerService,
    private datastoreService: DatastoreService
  ) { }

  ngOnInit() {
    this.spinner.show();

    // Set the current date to today for the calendar to default to today
    this.currentDate = new Date();
    this.selectedDate = this.currentDate;

    // Set max date as yesterday so the user cannot select a date until
    this.minDate = new Date(this.service.min_advance_datetime);
    this.maxDate = new Date(this.service.max_advance_datetime);

    console.log(this.minDate);
    console.log(this.maxDate);


    setInterval(function () {
      // console.log("hdhfh", )
      const tableHeader = document.getElementsByClassName("mat-calendar-table-header")
      if (tableHeader && tableHeader[0]) {
        if (tableHeader[0].children) {
          if (tableHeader[0].children[1]) {
            tableHeader[0].children[1].remove()
          }
        }
      }
      // const tableNextMonth = document.getElementsByClassName("mat-calendar-next-button")
      // if (tableNextMonth && tableNextMonth[0]) {
      //   if (tableNextMonth[0].children) {
      //     console.log(tableNextMonth[0].children)
      //     console.log(tableNextMonth[0].children.length)
      //     if(tableNextMonth[0].children.length === 4){
      //       tableNextMonth[0].children[3].insertAdjacentHTML("afterend",'<span class="cdk-visually-hidden">Next</span>')
      //     }
      //   }
      // }
      // const tablePrevMonth = document.getElementsByClassName("mat-calendar-previous-button")
      // if (tablePrevMonth && tablePrevMonth[0]) {
      //   if (tablePrevMonth[0].children) {
      //     console.log(tablePrevMonth[0].children)
      //     console.log(tablePrevMonth[0].children.length)
      //     if(tablePrevMonth[0].children.length === 4){
      //       tablePrevMonth[0].children[3].insertAdjacentHTML("afterend",'<span class="cdk-visually-hidden">Previous</span>')
      //     }
      //   }
      // }

    }, 1000);

    this.newCalendarRun(undefined);
  }

  async newCalendarRun(date) {
    // get the start time of the month selected
    const dateRange = this.getDateRange(date);
    const params = {
      service_id: this.service.id,
      start_date: dateRange.startDate,
      end_date: dateRange.endDate,
    };

    this.availabilityService
      .getSlots(this.location, params)
      .then(async (res: any) => {
        let days = [];
        this.tempSlots = [];
        res.times.forEach((timeslot) => {
          if (timeslot.available) {
            this.tempSlots.push(timeslot);
          }
        });
        console.log(" this.tempSlots", this.tempSlots)
        if (this.tempSlots.length === 0 && moment(params.start_date).isBefore(moment(this.service.max_advance_datetime))) {
          return await this.newCalendarRun(moment(params.start_date).add(1, "month").format())
        }
        this.startDate = moment(params.start_date).format('YYYY-MM-DD hh:mm')
        this.minDate = new Date(params.start_date);

        // this.calendar._goToDateInView(moment(params.start_date),'month')
        console.log("startDate", this.startDate)
        this.spinner.show();
        // work out days from the tempSlots
        this.tempSlots.forEach((slot) => {
          let formatedDate = moment(slot.start).format('YYYY-MM-DD');
          let found = days.find((daysDate) => daysDate.date == formatedDate);
          if (found) {
            found.spaces = found.spaces + 1;
          } else {
            days.push({ spaces: 0, date: formatedDate });
          }
        });

        await this.availabilityService.setAvailableDays(days);

        this.availableDays = days;

        if (days && days.length > 0) {
          this.newUpdateSlots(new Date(days[0].date));
        } else {
          this.newUpdateSlots(new Date());
        }
      });
  }

  async newUpdateSlots(date) {
    this.slots = [];
    // Update the selected date
    this.selectedDate = date;

    this.slots = this.tempSlots.filter((slot) => {
      let slotDate = moment(slot.start).format('YYYY-MM-DD');
      let selectedDate = moment(date).format('YYYY-MM-DD');
      if (slotDate == selectedDate) {
        return slot;
      }
    });

    // Sort from earliest to latest time
    this.slots.sort((a, b) => a.time - b.time);

    this.spinner.hide();
  }

  // Check if the date is unavailable and if so return false
  unavailableDates = (date: Date): boolean => {
    const momentDate = moment(date);
    if (this.availableDays) {
      return this.availableDays.some((day) => momentDate.isSame(day.date));
    } else {
      return false;
    }
  };

  @HostListener('click', ['$event'])
  onClick(event: any) {
    // get the clicked element
    let htlmEl = event.target
    if (!event.target.ariaLabel) {
      if (event.target.parentElement) {
        htlmEl = event.target.parentElement
      }
    }
    if (
      (htlmEl.ariaLabel &&
        htlmEl.ariaLabel.includes('Previous month')) ||
      (htlmEl.ariaLabel && htlmEl.ariaLabel.includes('Next month'))
    ) {
      this.spinner.show();
      let startOfMonth = moment(this.calendar.monthView._activeDate)
        .startOf('month')
        .format('YYYY-MM-DD');
      this.slots = [];
      this.tempSlots = [];
      this.startDate = startOfMonth;
      this.availableDays = undefined;
      this.newCalendarRun(startOfMonth);
    }
  }

  // Set the slot
  selectSlot(slot) {
    slot.datetime = moment(slot.start).format('YYYY-MM-DDTHH:mm:ss');
    this.selectedSlot = slot;
    this.availabilityService.setSelectedSlot(slot);
    this.selectSlotUpdate.emit(true);
    const endSlot = slot.datetime;
    this.availabilityService.setEndSlot(
      moment(endSlot).add(this.service.booking_time_step, 'm').toDate()
    );

    const timeString = moment(slot.start).format('HH:mm');
    this.a11yMessage = `You have selected ${timeString}`;
  }

  getDateRange(date) {
    const startDate = moment(date).startOf('month').format('YYYY-MM-DD hh:mm');
    const endDate = moment(date).endOf('month').format('YYYY-MM-DD hh:mm');
    return {
      startDate,
      endDate,
    };
  }
}
